import React from "react";
import { Link } from "gatsby";
import icon1 from "../../assets/images/icons/icon1.png";
import icon2 from "../../assets/images/icons/icon2.png";
import icon3 from "../../assets/images/icons/icon3.png";
import shape2 from "../../assets/images/services/service-shape2.png";

const OurProducts = () => {
  return (
    <div className="boxes-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-6">
            <Link className="single-boxes-item d-block cursor-pointer" to="/employee" target="_blank">
              <div className="icon">
                <img src={icon1} alt="banner" />
              </div>
              <h3>
                <Link to="#IntroOfHr">eHR</Link>
              </h3>
              <p>
                整合人力资源六大业务模块，
                <br />
                高效赋能企业人才数字化建设
              </p>

              <div className="shape1">
                <img src={shape2} alt="banner" />
              </div>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-6">
            <Link className="single-boxes-item d-block cursor-pointer" to="/hro" target="_blank">
              <div className="icon">
                <img src={icon2} alt="banner" />
              </div>
              <h3>
                <Link to="#IntroOfHro">HRO</Link>
              </h3>
              <p>
                专为人力资源服务商提供
                <br />
                全流程外包业务管理服务平台
              </p>

              <div className="shape1">
                <img src={shape2} alt="banner" />
              </div>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-sm-3 offset-md-3">
            <div className="single-boxes-item">
              <div className="icon">
                <img src={icon3} alt="banner" />
              </div>
              <h3>
                <Link to="#IntroOfPlatform">aPaaS</Link>
              </h3>
              <p>
                深度场景赋能，专注企业级应用开发
                <br />
                极速构建随需应变系统
              </p>
              <div className="shape1">
                <img src={shape2} alt="banner" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurProducts;
